"use client";

import { useEffect, useState, useRef } from "react";
import { Task, TaskResponse } from "./types";
import { getTaskId } from "./utils";

export const useTasks = () => {
  const [tasks, setTasks] = useState<Task[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [newItemId, setNewItemId] = useState<string | null>(null);
  const prevFirstIdRef = useRef<string | null>(null);

  useEffect(() => {
    const fetchTasks = async () => {
      try {
        const res = await fetch(
          "https://management-backend.opengpu.network/api/tasks",
        );
        const data = (await res.json()) as TaskResponse;

        if (data.status === "success") {
          let tasksData: Task[] = [];
          if (Array.isArray(data.data)) {
            tasksData = data.data;
          } else if (data.tasks) {
            tasksData = data.tasks;
          } else {
            tasksData = data.data.tasks;
          }
          const newTasks = tasksData.slice(0, 5);
          if (newTasks.length > 0) {
            const currentFirstId = getTaskId(newTasks[0]._id);
            if (
              prevFirstIdRef.current !== null &&
              prevFirstIdRef.current !== currentFirstId
            ) {
              setNewItemId(currentFirstId);
              setTimeout(() => setNewItemId(null), 500);
            }
            prevFirstIdRef.current = currentFirstId;
          }
          setTasks(newTasks);
          setIsFirstLoad(false);
        }
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        setIsFirstLoad(false);
      }
    };

    fetchTasks();
    const interval = setInterval(fetchTasks, 35000);

    return () => clearInterval(interval);
  }, []);

  return { tasks, isLoading, isFirstLoad, newItemId };
};
